import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type Chat3IconProps = Partial<SVGIconProps>;

const Chat3Icon: FC<Chat3IconProps> = (props) => (
  <SVGIcon viewBox="0 0 16 14" {...props}>
    <path
      d="M7.2128 0.625H6.42576C3.38308 0.625 0.916504 3.12241 0.916504 6.20312V8.59375C0.916504 9.47395 1.62124 10.1875 2.49058 10.1875H7.2128C9.82081 10.1875 11.935 8.04686 11.935 5.40625C11.935 5.02154 11.8901 4.64745 11.8054 4.28904C11.3085 2.18734 9.44085 0.625 7.2128 0.625Z"
      fill="currentColor"
      opacity="0.4"
    />
    <path
      d="M7.21294 10.1875C9.82095 10.1875 11.9352 8.04689 11.9352 5.40628C11.9352 5.02157 11.8903 4.64747 11.8056 4.28906C13.7365 5.1562 15.0833 7.11417 15.0833 9.39065V11.7813C15.0833 12.6615 14.3786 13.375 13.5092 13.375H8.78701C6.73093 13.375 4.98176 12.0446 4.3335 10.1875H7.21294Z"
      fill="currentColor"
    />
  </SVGIcon>
);

export default Chat3Icon;
